import { render, staticRenderFns } from "./feedbackInfo.vue?vue&type=template&id=55a8d34e&scoped=true"
import script from "./feedbackInfo.vue?vue&type=script&lang=js"
export * from "./feedbackInfo.vue?vue&type=script&lang=js"
import style0 from "./feedbackInfo.vue?vue&type=style&index=0&id=55a8d34e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8d34e",
  null
  
)

export default component.exports